import * as React from 'react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import icon_setting from '../imgs/icon_setting.svg';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconType: 'setting';
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
}

export const IconBtn = forwardRef<HTMLButtonElement, Props>(({ iconType, onClick, children, ...props }, ref) => {
  const getSrc = () => {
    if (iconType === 'setting') {
      return icon_setting;
    }
    return '';
  };
  return (
    <Body onClick={onClick} ref={ref} {...props}>
      <img src={getSrc()} alt="icon button" />
      {children}
    </Body>
  );
});
IconBtn.displayName = 'IconBtn';

const Body = styled.button``;
